import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Text } from 'components/typography/Text';

export const Transportation = () => {
  return (
    <>
      <Text size={16}>
        <FormattedMessage
          id='transportationDescription'
          values={{
            bold: (...chunks) => (
              <Text size={16} element='span' bold>
                {chunks}
              </Text>
            ),
          }}
        />
      </Text>
    </>
  );
};
